const normalizeRole = (value) =>
  String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");

export const canManageContent = (profile) => {
  const role = normalizeRole(profile?.role);
  return Boolean(
    profile?.is_staff === true ||
      profile?.is_superuser === true ||
      profile?.can_manage_content === true ||
      profile?.is_content_manager === true ||
      ["admin", "content_manager"].includes(role)
  );
};

export const contentRoleLabel = (profile) =>
  profile?.is_staff || profile?.is_superuser || normalizeRole(profile?.role) === "admin"
    ? "Administrator"
    : "Content manager";
